/* F2 ECO Aktionscode */
(function(){
  'use strict';
  if (window.F2Promo) return;

  var C = window.F2PROMO || {};
  var API = '/api/2026-07/graphql.json';
  var CACHE = 'f2promo_q_v3';
  var mem = {}, pending = {};

  /* ---------- Grundfunktionen ---------- */
  function promoCode(){ return String(C.code || '').trim(); }
  function promoActive(){
    return !!(promoCode() && !C.isB2B && C.endsAt && (C.endsAt * 1000) > Date.now());
  }
  function readCookie(name){
    var parts = document.cookie ? document.cookie.split('; ') : [];
    for (var i = 0; i < parts.length; i++){
      var eq = parts[i].indexOf('=');
      if (eq > -1 && parts[i].slice(0, eq) === name){
        try { return decodeURIComponent(parts[i].slice(eq + 1)); } catch(e){ return parts[i].slice(eq + 1); }
      }
    }
    return '';
  }
  function activeCode(){
    var raw = String(readCookie('discount_code') || C.cartCode || '').trim();
    return raw ? raw.split(',')[0].trim() : '';
  }
  function same(a, b){ return String(a || '').toUpperCase() === String(b || '').toUpperCase(); }
  function lang(){ return String(C.language || 'de').slice(0, 2).toLowerCase() === 'en' ? 'en' : 'de'; }
  function t(key){
    var m = (C.t && C.t[lang()]) || (C.t && C.t.de) || {};
    return (m[key] != null) ? m[key] : key;
  }
  function fill(str, vars){
    return String(str).replace(/\{(\w+)\}/g, function(_, k){ return (vars && vars[k] != null) ? vars[k] : ''; });
  }
  function esc(s){
    return String(s).replace(/[&<>"']/g, function(c){
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];
    });
  }
  function money(amount, currency){
    var n = Number(amount), cur = currency || 'EUR';
    if (!isFinite(n)) return '';
    try {
      if (lang() === 'en') return new Intl.NumberFormat('en-GB', { style: 'currency', currency: cur, minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n);
      var s = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n);
      return cur === 'EUR' ? '€' + s : s + ' ' + cur;
    }
    catch(e){ return n.toFixed(2).replace('.', ',') + ' ' + cur; }
  }
  function endsLabel(){
    if (!C.endsAt) return '';
    var d = new Date(C.endsAt * 1000);
    if (isNaN(d.getTime())) return '';
    try {
      return lang() === 'en'
        ? new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'short', year: 'numeric', timeZone: 'Europe/Vienna' }).format(d)
        : new Intl.DateTimeFormat('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric', timeZone: 'Europe/Vienna' }).format(d);
    } catch(e){
      return ('0' + d.getDate()).slice(-2) + '.' + ('0' + (d.getMonth() + 1)).slice(-2) + '.' + d.getFullYear();
    }
  }

  /* ---------- Positionen ---------- */
  function digits(x){ return String(x == null ? '' : x).replace(/\D/g, ''); }
  function normLines(x){
    var arr = Array.isArray(x) ? x : [{ id: x, q: 1 }];
    var out = [];
    for (var i = 0; i < arr.length; i++){
      var id = digits(arr[i] && arr[i].id);
      var q = parseInt((arr[i] && (arr[i].q != null ? arr[i].q : arr[i].quantity)) || 1, 10);
      if (id && q > 0) out.push({ id: id, q: q });
    }
    return out;
  }
  function linesFromEl(el){
    var raw = el.getAttribute('data-lines');
    if (raw){ try { return normLines(JSON.parse(raw)); } catch(e){} }
    return normLines(el.getAttribute('data-variant-id'));
  }

  /* ---------- Probewarenkorb ---------- */
  var QUOTE = 'mutation F2PromoQuote($input: CartInput!) { cartCreate(input: $input) { ' +
    'cart { discountCodes { code applicable } discountAllocations { discountedAmount { amount } } lines(first: 25) { nodes { ' +
    'cost { subtotalAmount { amount currencyCode } totalAmount { amount currencyCode } } } } } ' +
    'userErrors { message } } }';

  function cacheGet(key){
    if (mem[key]) return mem[key];
    try { var all = JSON.parse(sessionStorage.getItem(CACHE) || '{}'); return all[key] || null; } catch(e){ return null; }
  }
  function cacheSet(key, val){
    mem[key] = val;
    try {
      var all = JSON.parse(sessionStorage.getItem(CACHE) || '{}');
      all[key] = val;
      sessionStorage.setItem(CACHE, JSON.stringify(all));
    } catch(e){}
  }

  function quote(lines, code){
    var L = normLines(lines);
    if (!L.length || !code) return Promise.resolve(null);
    var key = L.map(function(l){ return l.id + 'x' + l.q; }).join(',') + '|' + String(code).toUpperCase() + '|' + String(C.country || '');
    var hit = cacheGet(key);
    if (hit) return Promise.resolve(hit);
    if (pending[key]) return pending[key];
    var input = {
      lines: L.map(function(l){ return { merchandiseId: 'gid://shopify/ProductVariant/' + l.id, quantity: l.q }; }),
      discountCodes: [String(code)]
    };
    if (C.country) input.buyerIdentity = { countryCode: String(C.country).toUpperCase() };
    return pending[key] = fetch(API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ query: QUOTE, variables: { input: input } })
    }).then(function(r){ return r.ok ? r.json() : null; })
      .then(function(j){
        var cart = j && j.data && j.data.cartCreate && j.data.cartCreate.cart;
        var nodes = cart && cart.lines && cart.lines.nodes;
        if (!cart || !nodes || nodes.length !== L.length) return null;
        var before = 0, after = 0, cur = '';
        for (var i = 0; i < nodes.length; i++){
          before += Number(nodes[i].cost.subtotalAmount.amount);
          after += Number(nodes[i].cost.totalAmount.amount);
          cur = nodes[i].cost.totalAmount.currencyCode;
        }
        var ca = cart.discountAllocations || [];
        for (var k = 0; k < ca.length; k++) after -= Number((ca[k].discountedAmount || {}).amount || 0);
        var dc = (cart.discountCodes || []).filter(function(x){ return same(x.code, code); })[0];
        var res = {
          applicable: !!(dc && dc.applicable && after < before - 0.004),
          before: Math.round(before * 100) / 100,
          after: Math.round(after * 100) / 100,
          currency: cur
        };
        cacheSet(key, res);
        return res;
      })
      .catch(function(){ return null; })
      .then(function(res){ delete pending[key]; return res; });
  }

  /* ---------- Gueltiger aktiver Code ---------- */
  function checkedCode(){
    var cur = activeCode();
    var ref = normLines(C.refLines || []);
    if (!cur || !ref.length) return Promise.resolve(cur);
    return quote(ref, cur).then(function(q){
      if (!q) return cur;
      return q.applicable ? cur : '';
    });
  }

  /* ---------- Code anwenden ---------- */
  function emit(){
    try { document.dispatchEvent(new CustomEvent('f2:promo-change', { detail: { code: activeCode() } })); } catch(e){}
  }
  function apply(code){
    code = String(code || promoCode());
    if (!code) return Promise.resolve(false);
    return checkedCode().then(function(other){
      if (other && !same(other, code)) return false;
      return send(code);
    });
  }
  function send(code){
    return fetch('/discount/' + encodeURIComponent(code) + '?redirect=%2Fcart.js', { credentials: 'same-origin' })
      .then(function(){
        return fetch('/cart/update.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ discount: code })
        }).catch(function(){});
      })
      .then(function(){ C.cartCode = code; emit(); return same(activeCode(), code); })
      .catch(function(){ emit(); return false; });
  }

  /* ---------- Zustand fuer Positionen ---------- */
  function stateFor(lines){
    if (C.isB2B) return Promise.resolve({ mode: 'none' });
    return checkedCode().then(function(cur){
      if (cur){
        return quote(lines, cur).then(function(q){
          if (!q || !q.applicable) return { mode: 'none', code: cur };
          return { mode: same(cur, promoCode()) ? 'promo' : 'partner', code: cur, price: q.after, before: q.before, currency: q.currency };
        });
      }
      if (!promoActive()) return { mode: 'none' };
      return quote(lines, promoCode()).then(function(q){
        if (!q || !q.applicable) return { mode: 'none' };
        return { mode: 'offer', code: promoCode(), price: q.after, before: q.before, currency: q.currency };
      });
    });
  }

  /* ---------- Box ---------- */
  function priceText(s, el){
    var per = parseFloat(el.getAttribute('data-per') || '0');
    if (per > 0) return money(s.price / per, s.currency) + '/' + esc(el.getAttribute('data-per-unit') || '');
    return money(s.price, s.currency);
  }
  function boxHtml(s, el){
    var p = '<b>' + priceText(s, el) + '</b>', code = '<b class="f2-promo__code">' + esc(s.code) + '</b>', e = endsLabel();
    if (s.mode === 'offer'){
      return '<div class="f2-promo__row">' +
          '<div class="f2-promo__text">' + fill(t('offer'), { code: code, price: p }) +
          (e ? '<span class="f2-promo__sub">' + esc(fill(t('until'), { date: e })) + '</span>' : '') + '</div>' +
          '<button type="button" class="f2-promo__btn" data-f2-promo-apply>' + esc(t('apply')) + '</button>' +
        '</div>';
    }
    if (s.mode === 'promo'){
      return '<div class="f2-promo__text">' + fill(t('active'), { code: code, price: p }) +
        '<span class="f2-promo__sub">' + esc(t('checkout')) + (e ? ' ' + esc(fill(t('until'), { date: e })) : '') + '</span></div>';
    }
    if (s.mode === 'partner'){
      return '<div class="f2-promo__text">' + fill(t('partner'), { code: code, price: p }) +
        '<span class="f2-promo__sub">' + esc(t('checkout')) + '</span></div>';
    }
    return '';
  }

  function renderBox(el, lines){
    if (!el) return Promise.resolve(null);
    if (lines != null){
      var L = normLines(lines);
      if (L.length === 1 && L[0].q === 1 && !el.hasAttribute('data-lines')) el.setAttribute('data-variant-id', L[0].id);
      else el.setAttribute('data-lines', JSON.stringify(L));
    }
    var use = linesFromEl(el);
    var ticket = String(Date.now()) + Math.random();
    el.setAttribute('data-ticket', ticket);
    return stateFor(use).then(function(s){
      if (el.getAttribute('data-ticket') !== ticket) return s;
      var html = (s && s.mode && s.mode !== 'none') ? boxHtml(s, el) : '';
      el.innerHTML = html;
      el.hidden = !html;
      el.setAttribute('data-mode', (s && s.mode) || 'none');
      return s;
    });
  }

  document.addEventListener('click', function(ev){
    var b = ev.target && ev.target.closest ? ev.target.closest('[data-f2-promo-apply]') : null;
    if (!b) return;
    ev.preventDefault();
    if (b.disabled) return;
    b.disabled = true;
    b.textContent = t('applying');
    apply(promoCode()).then(function(ok){ if (!ok) renderAll();  });
  });

  /* ---------- Ankuendigungsleiste ---------- */
  function renderBar(){
    var bars = document.querySelectorAll('[data-f2-promo-bar]');
    if (!bars.length) return Promise.resolve();
    if (C.isB2B){ paintBar(bars, ''); return Promise.resolve(); }
    return checkedCode().then(function(cur){
      var code = promoCode(), html = '';
      if (cur && !same(cur, code)){
        html = fill(esc(t('bar_partner')), { code: '<b class="f2-promo__code">' + esc(cur) + '</b>' });
      } else if (cur && promoActive()){
        html = fill(esc(t('bar_active')), { code: '<b class="f2-promo__code">' + esc(code) + '</b>' });
      } else if (promoActive()){
        html = '<span>' + fill(esc(t('bar_offer')), { code: '<b class="f2-promo__code">' + esc(code) + '</b>', percent: esc(C.percent || ''), date: esc(endsLabel()) }) + '</span>' +
               '<button type="button" class="f2-promo__btn f2-promo__btn--bar" data-f2-promo-apply>' + esc(t('apply')) + '</button>';
      }
      paintBar(bars, html);
    });
  }
  function paintBar(bars, html){
    for (var i = 0; i < bars.length; i++){
      bars[i].innerHTML = html;
      bars[i].hidden = !html;
      var sec = bars[i].closest('.shopify-section--announcement-bar');
      if (sec && sec.querySelectorAll('[data-f2-promo-bar]').length === sec.querySelectorAll('.announcement-bar p').length){
        sec.hidden = !html;
      }
    }
  }

  function renderAll(){
    renderBar();
    var boxes = document.querySelectorAll('[data-f2-promo-box]');
    for (var i = 0; i < boxes.length; i++) renderBox(boxes[i]);
  }

  /* ---------- Variantenwechsel auf der Produktseite ---------- */
  function pdpBoxes(){ return document.querySelectorAll('[data-f2-promo-box][data-f2-promo-pdp]'); }
  function syncFromForms(){
    var boxes = pdpBoxes();
    for (var i = 0; i < boxes.length; i++){
      var fid = boxes[i].getAttribute('data-form-id');
      var form = fid ? document.getElementById(fid) : null;
      var inp = form ? form.querySelector('[name="id"]') : null;
      var v = inp ? digits(inp.value) : '';
      if (v && v !== digits(boxes[i].getAttribute('data-variant-id'))) renderBox(boxes[i], v);
    }
  }
  function onVariant(ev){
    var d = (ev && ev.detail) || {};
    var v = d.variant || d.currentVariant || d.selectedVariant || null;
    var id = digits((v && v.id) || d.variantId || '');
    var boxes = pdpBoxes();
    if (!id){ setTimeout(syncFromForms, 60); return; }
    for (var i = 0; i < boxes.length; i++){
      if (id !== digits(boxes[i].getAttribute('data-variant-id'))) renderBox(boxes[i], id);
    }
  }

  function init(){
    try {
      var qp = new URLSearchParams(location.search).get('discount');
      if (qp && !activeCode()){
        fetch('/discount/' + encodeURIComponent(qp) + '?redirect=%2Fcart.js', { credentials: 'same-origin' })
          .then(emit).catch(function(){});
      }
    } catch(e){}
    renderAll();
    var evs = (C.variantEvents && C.variantEvents.length) ? C.variantEvents : ['variant:change'];
    for (var i = 0; i < evs.length; i++) document.addEventListener(evs[i], onVariant);
    document.addEventListener('change', function(){ if (pdpBoxes().length) setTimeout(syncFromForms, 60); });
    document.addEventListener('f2:promo-change', renderAll);
  }

  window.F2Promo = {
    active: promoActive,
    code: promoCode,
    activeCode: activeCode,
    checkedCode: checkedCode,
    quote: quote,
    apply: apply,
    stateFor: stateFor,
    renderBox: renderBox,
    renderAll: renderAll,
    money: money,
    endsLabel: endsLabel,
    t: t
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();